<template>
  <div class="container">
    <generic-table
      ref="datatable"
      :title="$t('apis')"
      :columns="columns"
      :column_search="true"
      mode="table"
      resource_url="/api/datatables"
    >
      <template v-slot:buttons>
        <!-- <button class="button is-secondary is-rounded" @click="manage">
          <span class="icon"><i class="fa fa-list"></i></span>
          <span>{{ $t("manage") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button> -->
      </template>
      <template #item="item">
        <div class="card">
          <header class="card-header">
            <p class="card-header-title">{{ item.name }}</p>
            <!-- <button class="card-header-icon" aria-label="more options">
              <span class="icon">
                <i class="fa fa-angle-down" aria-hidden="true"></i>
              </span>
            </button> -->
          </header>
          <div class="card-content">
            <div class="content">
              {{ item }}
              <br />
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item button">
              <span class="icon"><i class="fa fa-edit"></i></span>
              <span>{{ $t("edit") }}</span>
            </a>
            <a class="card-footer-item button" @click="delete_report(item)">
              <span class="icon"><i class="fa fa-trash"></i></span>
              <span>{{ $t("delete") }}</span>
            </a>
            <a class="card-footer-item button" @click="execute_report(item)">
              <span class="icon"><i class="fa fa-bolt"></i></span>
              <span>{{ $t("execute") }}</span>
            </a>
          </footer>
        </div>
      </template>
    </generic-table>
    <log-modal ref="log_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  get,
  error_message,
  format_date_time,
  format_currency,
} from "@/utils";
import router from "@/router";
import LogModal from "../log_modal/Index.vue";

export default {
  name: "ReportsDatatable",
  components: { GenericTable, LogModal },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          width: "75%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.$t(row.name) || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  v.$refs.log_modal.show_modal(uuid);
                },
              },
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("delete"),
              //   icon: "fa fa-trash",
              //   icon_class: "is-small has-text-danger",
              //   click: (e) => {
              //     let uuid = e.detail.uuid;
              //     confirm_deletion_dialog(
              //       v.$t("are you sure to delete bill?"),
              //       v,
              //       () => {
              //         del("/fel/bill", { uuid: uuid })
              //           .then(() => {
              //             v.refresh();
              //           })
              //           .catch((error) => {
              //             error_message(error);
              //           });
              //       }
              //     );
              //   },
              // },
            ]);
          },
        },
      ],
      reports: [],
    };
  },
  methods: {
    format_date_time,
    format_currency,
    create() {
      let v = this;
      v.$refs.report_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    // init_complete(opts) {
    //   let v = this;
    //   let { settings, json } = opts;
    //   let layout_table = window.jQuery(".dt-layout-table");
    //   // layout_table.addClass("is-hidden");
    // },
    // draw_as_list(json) {
    //   let v = this;
    //   // console.log("draw", json);
    //   v.reports = json;
    // },
    manage() {
      let v = this;
      v.$router.push({ path: "/report/manage" });
    },
    delete_report(report) {
      let v = this;
      confirm_deletion_dialog(v.$t("are you sure to delete report?"), v, () => {
        del("/report", { uuid: report.uuid })
          .then(() => {
            v.refresh();
          })
          .catch((error) => {
            error_message(error);
          });
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
